import React, { useState } from 'react';
import { Star, Quote } from 'lucide-react';

const Testimonials = () => {
  const [activeTab, setActiveTab] = useState('owners');

  const testimonials = {
    owners: [
      {
        name: 'Priya Natarajan',
        role: 'Dog Mom · Golden Retriever, Bruno',
        location: 'RS Puram, Coimbatore',
        avatar: 'PN',
        avatarColor: 'bg-teal-500',
        rating: 5,
        text: 'I was travelling to Ooty for 5 days with no one to care for Bruno. I found "Paws & Whiskers Boarding Home" on PetCares in under 2 minutes. Called them, confirmed, and left the next morning without a single worry. I even got photo updates from the owner. This is exactly what Coimbatore needed.',
      },
      {
        name: 'Arun Krishnamoorthy',
        role: 'Cat Parent · Persian cats, Sona & Roja',
        location: 'Gandhipuram, Coimbatore',
        avatar: 'AK',
        avatarColor: 'bg-orange-500',
        rating: 5,
        text: 'At 11 PM, Roja suddenly stopped eating and was making strange sounds. I was panicking. Opened PetCares, found Dr. Senthilkumar on Avinashi Road — called, got through in seconds. He guided me over the phone and told me to come in. We were there in 20 minutes. She had a minor throat infection. He saved her night.',
      },
      {
        name: 'Meenakshi Sundaram',
        role: 'Pet Owner · Rabbit mom',
        location: 'Saibaba Colony, Coimbatore',
        avatar: 'MS',
        avatarColor: 'bg-purple-500',
        rating: 5,
        text: 'No one told me rabbit care is so specialised. When Biscuit stopped moving, I searched everywhere — most vets don\'t even treat rabbits. PetCares showed me Dr. Senthilkumar who specifically handles exotic animals. Within 30 minutes I was at his clinic. I don\'t know what I would have done without this platform.',
      },
      {
        name: 'Vijay Soundararajan',
        role: 'Dog owner · Labrador, Rocky',
        location: 'Peelamedu, Coimbatore',
        avatar: 'VS',
        avatarColor: 'bg-blue-500',
        rating: 5,
        text: 'I travel frequently for work and Rocky always makes me guilty whenever I pack my bag. After finding Fur & Feathers Pet Stay, that guilt is gone. They accepted him same-day once when my trip got advanced, gave him a private room, and even sent me a video of him playing. PetCares is now my first stop before every trip.',
      },
    ],
    shops: [
      {
        name: 'Ramesh Kumar',
        role: 'Owner · Happy Tails Pet Daycare',
        location: 'Saibaba Colony, Coimbatore',
        avatar: 'RK',
        avatarColor: 'bg-green-600',
        rating: 5,
        text: 'Before PetCares, I depended entirely on word of mouth and walk-ins. After listing on PetCares, we started getting 8–12 enquiry calls a week from verified pet owners. Our boarding occupancy has gone from 60% to nearly full most weekends. The best part — they verified our facility properly before listing us. That builds trust for both sides.',
      },
      {
        name: 'Suresh Annamalai',
        role: 'Owner · Coimbatore Pet Boarding & Care',
        location: 'RS Puram, Coimbatore',
        avatar: 'SA',
        avatarColor: 'bg-teal-600',
        rating: 5,
        text: 'I was sceptical. I thought, why would a platform help my small shop? But the PetCares team actually came to my place, understood my services, and listed us properly showing exactly what we offer. No commission taken. Customers contact me directly. It\'s just visibility — and it\'s real visibility. I have referred two other pet shop owners already.',
      },
      {
        name: 'Lakshmi Murugesan',
        role: 'Owner · Nature\'s Nest Pet Care',
        location: 'Singanallur, Coimbatore',
        avatar: 'LM',
        avatarColor: 'bg-emerald-500',
        rating: 5,
        text: 'We specialise in exotic animals — reptiles, birds — and for years people didn\'t know we existed. PetCares gave us a category tag "Exotic Pet Care" and now we get calls from across Coimbatore. One customer drove from Peelamedu just because he found us on PetCares. Our niche finally has an audience.',
      },
    ],
    doctors: [
      {
        name: 'Dr. S. Kavitha Rajan',
        role: 'BVSc & AH · Paws & Care Veterinary Hospital',
        location: 'RS Puram, Coimbatore',
        avatar: 'KR',
        avatarColor: 'bg-red-500',
        rating: 5,
        text: 'Emergency calls used to come from people who found my number through someone\'s contact list — no context, no idea what animal or problem. PetCares clients call me with their pet\'s situation already described. They found me because of my specialty. The quality of emergency calls has improved dramatically. It is more efficient for my practice.',
      },
      {
        name: 'Dr. M. Arjun Krishnan',
        role: 'BVSc & AH · CityPet Multispeciality Clinic',
        location: 'Gandhipuram, Coimbatore',
        avatar: 'AK',
        avatarColor: 'bg-rose-500',
        rating: 5,
        text: 'I was worried about random midnight calls increasing my workload. It\'s the opposite — because PetCares lists me as an "Emergency Specialist", the calls I get are genuine emergencies. I have handled 4 critical cases in the last month that came directly from the platform. As a vet, this is exactly the kind of work I exist to do.',
      },
      {
        name: 'Dr. Priya Selvam',
        role: 'BVSc & AH · Happy Pets Veterinary Clinic',
        location: 'Saibaba Colony, Coimbatore',
        avatar: 'PS',
        avatarColor: 'bg-pink-500',
        rating: 5,
        text: 'The PetCares team visited my clinic, verified my registration documents, understood my specialties, and listed me accurately. There was no time pressure, no technical skills needed from my side. I just received a WhatsApp with my listing to review and approve. That respect for my time convinced me they are serious about doing this right.',
      },
    ],
  };

  const tabs = [
    { id: 'owners', label: '🐾 Pet Owners' },
    { id: 'shops', label: '🏪 Pet Shop Owners' },
    { id: 'doctors', label: '🩺 Veterinarians' },
  ];

  const current = testimonials[activeTab];

  return (
    <section id="testimonials" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <span className="inline-block text-brand-teal font-bold tracking-widest uppercase text-xs mb-3 bg-teal-50 px-4 py-1.5 rounded-full border border-teal-100">
            Real Stories
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4">
            Trust Built on<br/>
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-brand-teal to-brand-orange">
              Real Experiences
            </span>
          </h2>
          <p className="text-xl text-gray-500">
            PetCares serves three communities. Here is what each of them says about us.
          </p>
        </div>

        {/* Tabs */}
        <div className="flex justify-center gap-2 mb-10">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-5 py-2.5 rounded-full text-sm font-bold transition-all ${
                activeTab === tab.id
                  ? 'bg-brand-dark text-white shadow-md'
                  : 'bg-gray-100 text-gray-500 hover:bg-gray-200'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {current.map((t, i) => (
            <div key={i} className="bg-gray-50 rounded-3xl p-7 border border-gray-100 hover:shadow-lg transition-all flex flex-col">
              <Quote className="text-gray-200 mb-4 flex-shrink-0" size={36} fill="currentColor" />

              <p className="text-gray-700 text-[15px] leading-relaxed mb-6 flex-grow">&ldquo;{t.text}&rdquo;</p>

              <div className="flex items-center gap-1 mb-5">
                {[...Array(t.rating)].map((_, s) => (
                  <Star key={s} size={14} className="text-yellow-400" fill="currentColor" />
                ))}
              </div>

              <div className="flex items-center gap-3 border-t border-gray-200 pt-5">
                <div className={`w-11 h-11 rounded-full ${t.avatarColor} flex items-center justify-center text-white font-bold text-sm flex-shrink-0`}>
                  {t.avatar}
                </div>
                <div>
                  <p className="font-bold text-gray-900 text-sm">{t.name}</p>
                  <p className="text-gray-500 text-xs">{t.role}</p>
                  <p className="text-brand-teal text-xs font-medium">{t.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Testimonials;
